/**
 * RailColapsavel — envolve o painel lateral de KPIs (ContextRail) de
 * Terceiros / Pintura & Lacagem, adicionando recolher/expandir (F8 / #16).
 *
 * - Expandido: mostra um botão "‹" discreto no topo + o conteúdo do rail.
 * - Recolhido: mostra só uma faixa estreita com botão "›" e o rótulo na
 *   vertical. A largura da coluna em si é controlada pela grade da página
 *   (ThreeZoneGrid recebe $colapsado), não por este componente.
 *
 * O estado vem do hook useRailColapsado (persistido por página). A página
 * deve tratar a exportação: passar colapsado=false durante a captura para o
 * rail sair inteiro na imagem/PDF.
 */
import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import {
  Cabecalho,
  ColapsadoStrip,
  RotuloVertical,
  ToggleBtn,
} from "./styles.jsx";

function RailColapsavel({ colapsado, onAlternar, children, rotulo = "Indicadores" }) {
  if (colapsado) {
    return (
      <ColapsadoStrip>
        <ToggleBtn
          type="button"
          onClick={onAlternar}
          aria-label={`Expandir painel de ${rotulo.toLowerCase()}`}
          aria-expanded={false}
          title={`Expandir ${rotulo}`}
        >
          <FiChevronRight aria-hidden="true" />
        </ToggleBtn>
        <RotuloVertical>{rotulo}</RotuloVertical>
      </ColapsadoStrip>
    );
  }

  return (
    <>
      <Cabecalho>
        <ToggleBtn
          type="button"
          onClick={onAlternar}
          aria-label={`Recolher painel de ${rotulo.toLowerCase()}`}
          aria-expanded
          title={`Recolher ${rotulo}`}
        >
          <FiChevronLeft aria-hidden="true" />
        </ToggleBtn>
      </Cabecalho>
      {children}
    </>
  );
}

export default RailColapsavel;
